import React from 'react';

import { Badge, Callout, Step } from './shared';

const ConnectSlack: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">Connect Slack</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      Connecting Slack lets you receive AI-generated project summaries and delivery notifications directly in your Slack
      workspace. The integration links <em>your MFlow account</em> to a Slack workspace — it is per-user, not
      per-organisation.
    </p>

    <h3 className="font-semibold mb-3">Step-by-step</h3>
    <div className="space-y-3 mb-6">
      <Step n={1}>
        Open <strong>Integrations</strong> from the sidebar and locate the <strong>Slack</strong> card.
      </Step>
      <Step n={2}>
        Click <strong>Connect Slack</strong>. A popup will open with Slack&apos;s OAuth consent screen.
      </Step>
      <Step n={3}>
        Select the Slack workspace where you want to receive notifications and click <strong>Allow</strong>.
      </Step>
      <Step n={4}>
        The popup closes automatically and the Slack card updates to <Badge color="badge-success">Connected</Badge>{' '}
        showing your workspace ID and connection date.
      </Step>
    </div>

    <Callout type="info">
      MFlow sends messages to Slack using a bot token scoped to your account only. It does not post channel-wide
      messages or read your Slack messages.
    </Callout>

    <h3 className="font-semibold mt-5 mb-3">Disconnecting Slack</h3>
    <p className="text-sm text-base-content/70 leading-relaxed">
      Click <strong>Disconnect</strong> on the Slack card. The Slack bot token is revoked and no further messages will
      be sent.
    </p>
  </div>
);

export default ConnectSlack;
